import { InnerBlocks, RichText, useBlockProps } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import React from 'react';

interface SaveProps {
  attributes: {
    icon?: string;
    headline?: string;
  };
}

const Save: React.FC<SaveProps> = ({ attributes: { headline, icon } }) => {
  return (
    <aside {...useBlockProps.save()}>
      <header className="card__header">
        <h3 className="card__title">
          <i className={icon}></i>
          <RichText.Content  value={headline} />
        </h3>
      </header>
      <div className="card__body">
        <InnerBlocks.Content />
      </div>
    </aside>
  );
};

export default Save;
